/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BidManagementExportOrderResponse } from './BidManagementExportOrderResponse';

export type BidManagementExportOrderResponseApiRespoonse = {
    data?: BidManagementExportOrderResponse;
    status?: BidManagementExportOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BidManagementExportOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

